export default __webpack_public_path__ + "static/forme-up-7ab61d7261f4a1e7d89a72d590e7e31c.png";